import InformationFiles from "./InformationFiles";
export default InformationFiles;
